import PopoverCompanySystem from './PopoverCompanySystem';
import './PopoverCompanySystem.scss';

export default PopoverCompanySystem;
